/**
 * @module mobile-menu
 *
 * Handles opening and closing the mobile menu.
 */

import { selectOne, selectMany, getWindow, addClass, removeClass } from './utils/dom-utils';


const VISIBLE_CLASS_NAME = 'visible';
const HIDDEN_CLASS_NAME = 'tw-hidden';

export default function initMobileMenu() {

  getWindow().addEventListener('load', () => {

    const openMenuIcon = selectOne('.mobile-menu-open');
    const closeMenuIcon = selectOne('.mobile-menu-close');
    const mobileMenu = selectOne('.mobile-menu');

    if(mobileMenu){
      closeMenuIcon.addEventListener('click', () => {
        addClass(closeMenuIcon, HIDDEN_CLASS_NAME);
        removeClass(mobileMenu, VISIBLE_CLASS_NAME);
      });

      openMenuIcon.addEventListener('click', () => {
        removeClass(closeMenuIcon, HIDDEN_CLASS_NAME);
        addClass(mobileMenu, VISIBLE_CLASS_NAME);
      });


      var mobile_menu_header = selectMany(".mobile-menu button");
      var mobile_menu_footer = selectMany(".mobile-footer-menu button");
      const BOUNCE_CONSTANT = 200;

      (mobile_menu_header.concat(mobile_menu_footer)).forEach(function (el, i) {
        if(el.dataset.for){
          var calledRecently = false;
          var toggle = document.getElementById(el.dataset.for);

          var toggleOnce = function(options){
            if (!calledRecently) {
              if(options && options.forceExpanded){
                 toggle.checked = true;
              }else {
                toggle.click();
              }
            }

            calledRecently = true;
            setTimeout(function(){calledRecently = false}, BOUNCE_CONSTANT);
          }

          el.addEventListener('click', function(e) {
            toggleOnce();
          });

          el.addEventListener('focus', function(e) {
            toggleOnce({forceExpanded:true});
          });
        }
      });

    }
  });

}